// SpecList.jsx
import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisVertical,
  faInfoCircle,
  faCopy
} from '@fortawesome/free-solid-svg-icons';

import { filter_tmpl_specialist } from '../../../../components/DiseaseSpecializationFilter/data';
import './style.css';

const getListSpec = ()=>{
  return ({
    specializations: filter_tmpl_specialist.specialization.map((s,i)=>{ return Object.assign(s, { number: i+1 })}),
    dissease_san: filter_tmpl_specialist.disease_type.slice(0,6).map((s,i)=>{ return Object.assign(s, { number: i+1 })}),
    dissease_spec: filter_tmpl_specialist.disease_type.slice(6).map((s,i)=>{ return Object.assign(s, { number: i+1 })})
  });
}

const SpecList = () => {
  const [activeTab, setActiveTab] = useState('specializations');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [copiedItem, setCopiedItem] = useState(null);
  const [referenceData, setReferenceData] = useState(getListSpec());


  const columnsConfig = {
    specializations: [
      { key: 'number', label: 'Номер', sortable: true, width: '15%' },
      { key: 'label', label: 'Назва', sortable: true, width: '65%' },
      { key: 'description', label: 'Примітка', sortable: true, width: '20%' },
    ],
    dissease_san: [
      { key: 'number', label: 'Номер', sortable: true, width: '15%' },
      { key: 'label', label: 'Назва', sortable: true, width: '65%' },
      { key: 'description', label: 'Примітка', sortable: true, width: '20%' },
    ],
    dissease_spec: [
      { key: 'number', label: 'Номер', sortable: true, width: '15%' },
      { key: 'label', label: 'Назва', sortable: true, width: '65%' },
      { key: 'description', label: 'Примітка', sortable: true, width: '20%' },
    ]
  };

  // Колонки для разных вкладок
  const _columnsConfig = {
    system: [
      { key: 'title', label: 'Назва ролі', sortable: true, width: '15%' },
      { key: 'code', label: 'Код', sortable: true, width: '10%' },
      { key: 'description', label: 'Опис', sortable: true, width: '20%' },
      { key: 'permissions', label: 'Права доступу', sortable: true, width: '15%' },
      { key: 'responsibilities', label: 'Обов\'язки', sortable: true, width: '15%' },
      { key: 'accessLevel', label: 'Рівень доступу', sortable: true, width: '10%' },
      { key: 'status', label: 'Статус', sortable: true, width: '8%' },
      { key: 'note', label: 'Примітка', sortable: true, width: '7%' },
      { key: 'actions', label: 'Дії', sortable: false, width: '5%' }
    ],
    kindergarten: [
      { key: 'title', label: 'Назва ролі', sortable: true, width: '15%' },
      { key: 'code', label: 'Код', sortable: true, width: '10%' },
      { key: 'description', label: 'Опис', sortable: true, width: '20%' },
      { key: 'permissions', label: 'Права доступу', sortable: true, width: '15%' },
      { key: 'responsibilities', label: 'Обов\'язки', sortable: true, width: '15%' },
      { key: 'accessLevel', label: 'Рівень доступу', sortable: true, width: '10%' },
      { key: 'status', label: 'Статус', sortable: true, width: '8%' },
      { key: 'note', label: 'Примітка', sortable: true, width: '7%' },
      { key: 'actions', label: 'Дії', sortable: false, width: '5%' }
    ],
    technical: [
      { key: 'title', label: 'Назва ролі', sortable: true, width: '15%' },
      { key: 'code', label: 'Код', sortable: true, width: '10%' },
      { key: 'description', label: 'Опис', sortable: true, width: '20%' },
      { key: 'permissions', label: 'Права доступу', sortable: true, width: '15%' },
      { key: 'responsibilities', label: 'Обов\'язки', sortable: true, width: '15%' },
      { key: 'accessLevel', label: 'Рівень доступу', sortable: true, width: '10%' },
      { key: 'status', label: 'Статус', sortable: true, width: '8%' },
      { key: 'note', label: 'Примітка', sortable: true, width: '7%' },
      { key: 'actions', label: 'Дії', sortable: false, width: '5%' }
    ]
  };

  const columns = columnsConfig[activeTab];

  // Функция сортировки
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Сортированные данные
  const sortedData = useMemo(() => {
    const data = referenceData[activeTab];
    if (!sortConfig.key) return data;
    
    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key] || '';
      const bValue = b[sortConfig.key] || '';

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [referenceData, activeTab, sortConfig]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleMenuToggle = (index) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleMenuClose = () => {
    setActiveMenuIndex(null);
  };

  const handleCopyToClipboard = async (text, item) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedItem(item.id);
      setTimeout(() => setCopiedItem(null), 2000);
    } catch (err) {
      console.error('Помилка копіювання: ', err);
    }
  };

  const handleActionSelect = (actionId, item) => {
    if (actionId === 'view') {
      // Показать детальную информацию
      let message = '';
      if (activeTab === 'system' || activeTab === 'kindergarten' || activeTab === 'technical') {
        message = `Роль: ${item.title}\nКод: ${item.code}\nОпис: ${item.description}\nПрава доступу: ${item.permissions}\nОбов'язки: ${item.responsibilities}\nРівень доступу: ${item.accessLevel}\nСтатус: ${item.status}\nПримітка: ${item.note}`;
      }
      alert(message);
    } else if (actionId === 'copy') {
      // Копировать код для использования в формах
      handleCopyToClipboard(item.code, item);
    }
    setActiveMenuIndex(null);
  };

  const ActionsMenu = ({ onActionSelect, onClose, item }) => {
    const actions = [
      {
        id: 'view',
        label: 'Переглянути деталі',
        icon: faInfoCircle
      },
      {
        id: 'copy',
        label: 'Копіювати код',
        icon: faCopy
      }
    ];

    return (
      <div className="actions-dropdown">
        {actions.map((action) => (
          <button
            key={action.id}
            className="dropdown-item d-flex align-items-center gap-2 p-2"
            onClick={() => onActionSelect(action.id, item)}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
              width: '100%',
              textAlign: 'left',
              fontSize: '14px',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <FontAwesomeIcon icon={action.icon} style={{ width: '16px', color: '#6c757d' }} />
            <span style={{ color: '#212529' }}>{action.label}</span>
          </button>
        ))}
        
        <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
          <button
            className="btn btn-sm btn-outline-secondary w-100"
            onClick={onClose}
            style={{ fontSize: '12px' }}
          >
            Скасувати
          </button>
        </div>
      </div>
    );
  };

  

  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          {/* Панель табов */}
          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Довідник спеціалізацій</span>
              <ul className="queuetable-year-tabs nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'specializations' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('specializations');
                      setSortConfig({ key: null, direction: 'asc' });
                      setReferenceData(getListSpec('specializations'));
                    }}
                  >
                    Спеціалізація
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Уведомление о копировании */}
          {copiedItem && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              <FontAwesomeIcon icon={faCopy} className="me-2" />
              Назва успішно скопійовано в буфер обміну!
            </div>
          )}

          {/* Таблица */}
          <div className="card queuetable-table-card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table queuetable-table align-middle mb-0">
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th 
                          key={column.key}
                          style={{ width: column.width }}
                          onClick={() => column.sortable && handleSort(column.key)}
                        >
                          <div className="d-flex align-items-center">
                            {column.label}
                            {column.sortable && (
                              <FontAwesomeIcon 
                                icon={getSortIcon(column.key)} 
                                className="ms-1" 
                                style={{ fontSize: '12px' }}
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.map((item, index) => (
                      <tr key={item.id}>
                        {/* Динамическое отображение колонок в зависимости от вкладки */}
                        {columns.map((column) => {
                          if (column.key === 'actions') {
                            return (
                              <td key="actions" className="queuetable-actions text-end">
                                <div className="actions-menu-container" style={{ position: 'relative', display: 'inline-block' }}>
                                  <button
                                    className="btn btn-sm btn-link text-decoration-none p-0"
                                    onClick={() => handleMenuToggle(index)}
                                    style={{ color: '#0069ff' }}
                                  >
                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                  </button>
                                  
                                  {activeMenuIndex === index && (
                                    <ActionsMenu 
                                      onActionSelect={handleActionSelect}
                                      onClose={handleMenuClose}
                                      item={item}
                                    />
                                  )}
                                </div>
                              </td>
                            );
                          }
                          
                          return (
                            <td key={column.key}>
                              {item[column.key]}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Пагинация */}
              <div className="d-flex align-items-center mt-4 queuetable-pagination-wrapper">
                <div className="queuetable-pagination-info">
                  Всього {sortedData.length} записів
                </div>
              </div>
            </div>
          </div>

          {/* Информационное сообщение */}
          <div className="alert alert-info mt-3" role="alert">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            <strong>Довідник спеціалізацій</strong> - цей довідник містить опис спеціалізацій, доступних у системі. 
          </div>
        </div>
      </div>
    </main>
  );
};

export default SpecList;